(() => {
  "use strict";

  const CONFIG = {
    partnerUrl: "https://www.clicklease.com/partner/%20cloudray",
    apiUrl: "https://app.clicklease.com/api/estimatedPaymentAmount/",
    minAmount: 500,
    maxAmount: 30000
  };

  const SELECTORS = {
    productInfo: ".hdt-col.hdt-product-info-wrapp",
    collectionCards: ".hdt-shop-content.hdt-col .hdt-card-product",
    cardPriceWrapper: ".hdt-price-wrapp.hdt-text-base",
    cardPrice: ".hdt-price .hdt-money"
  };

  const scriptUrl = document.currentScript?.src || "";
  const assetBaseUrl = scriptUrl ? new URL(".", scriptUrl).href : "";
  const pendingRequests = new WeakMap();
  const observedPriceWrappers = new WeakSet();

  function assetUrl(filename) {
    return assetBaseUrl ? new URL(filename, assetBaseUrl).href : filename;
  }

  function parsePrice(text) {
    if (!text) return NaN;

    const match = text.replace(/,/g, "").match(/\d+(?:\.\d{1,2})?/);
    return match ? Number(match[0]) : NaN;
  }

  function parseMonthlyPayment(responseText) {
    try {
      const response = JSON.parse(responseText);
      const match = String(response.object ?? "")
        .replace(/,/g, "")
        .match(/\d+(?:\.\d{1,2})?/);

      return match ? match[0] : null;
    } catch (error) {
      console.error("Clicklease response parsing failed:", error);
      return null;
    }
  }

  function injectStyles() {
    if (document.getElementById("clicklease-styles")) return;

    const style = document.createElement("style");
    style.id = "clicklease-styles";
    style.textContent = `
      .ClkButton {
        box-sizing: border-box;
      }

      .ClkButton--product {
        container-type: inline-size;
        display: block !important;
        flex: 0 0 auto;
        align-self: stretch;
        width: min(560px, 100%) !important;
        max-width: 560px !important;
        margin: 12px 0 2px;
      }

      .clk-product-price-host {
        flex: 1 1 100% !important;
        width: 100% !important;
        min-width: 0;
      }

      .clk-product-finance {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        gap: 9px;
        width: 100%;
        min-height: 46px;
        padding: 7px 8px 7px 11px;
        border: 1px solid #d7edf7;
        border-radius: 8px;
        background: linear-gradient(
          100deg,
          #f6fcff 0%,
          #eef9fd 58%,
          #f8fdff 100%
        );
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
        color: #344054 !important;
        font-family: inherit;
        line-height: 1.2;
        text-align: left;
        text-decoration: none !important;
        text-transform: none;
        white-space: nowrap;
        box-sizing: border-box;
        cursor: pointer;
        transition:
          border-color 0.2s ease,
          box-shadow 0.2s ease,
          transform 0.2s ease;
      }

      .clk-product-finance:hover {
        border-color: #9fdcf1;
        box-shadow:
          inset 0 1px 0 #ffffff,
          0 4px 12px rgba(2, 166, 223, 0.1);
        transform: translateY(-1px);
      }

      .clk-product-finance:focus-visible {
        outline: 2px solid #02a6df;
        outline-offset: 2px;
      }

      .clk-product-finance__copy {
        display: flex;
        flex: 1 1 auto;
        align-items: baseline;
        flex-wrap: nowrap;
        gap: 3px;
        min-width: 0;
        white-space: nowrap;
      }

      .clk-product-finance__label,
      .clk-product-finance__with {
        color: #59636a;
        font-size: 13px;
        font-weight: 400;
      }

      .clk-product-finance__amount {
        color: #02a6df;
        font-size: 17px;
        font-weight: 750;
        letter-spacing: -0.2px;
      }

      .clk-product-finance__period {
        color: #59636a;
        font-size: 13px;
        font-weight: 600;
      }

      .clk-product-finance__brand {
        color: #59636a;
        font-size: 14px;
        font-weight: 700;
        letter-spacing: -0.2px;
        white-space: nowrap;
      }

      .clk-product-finance__brand-click {
        color: #02a6df;
      }

      .clk-product-finance__cta {
        position: relative;
        display: inline-flex;
        flex: 0 0 auto;
        align-items: center;
        justify-content: center;
        min-width: 100px;
        min-height: 28px;
        padding: 0 22px;
        border-radius: 999px;
        background: #02a6df;
        color: #ffffff;
        font-size: 10px;
        font-weight: 700;
        line-height: 1;
        letter-spacing: 0.45px;
        text-align: center;
        text-transform: uppercase;
        white-space: nowrap;
        transition: background-color 0.2s ease;
      }

      .clk-product-finance:hover .clk-product-finance__cta {
        background: #008fc4;
      }

      .clk-finance-arrow {
        display: block;
        width: 9px;
        height: 9px;
        object-fit: contain;
        transition: transform 0.2s ease;
      }

      .clk-product-finance__cta .clk-finance-arrow,
      .clk-card-finance__cta .clk-finance-arrow {
        position: absolute;
        top: 50%;
        right: 9px;
        margin-top: -4.5px;
      }

      .clk-product-finance:hover .clk-finance-arrow,
      .clk-card-finance:hover .clk-finance-arrow {
        transform: translateX(2px);
      }

      .ClkButton--collection {
        container-type: inline-size;
        width: 100%;
        max-width: 100%;
        margin: 8px 0 0;
      }

      .clk-card-finance {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        width: 100%;
        min-height: 52px;
        padding: 8px 10px;
        border: 1px solid #d8eff8;
        border-radius: 8px;
        background: #f5fbfe;
        color: #344054 !important;
        font-family: inherit;
        text-align: left;
        text-decoration: none !important;
        text-transform: none;
        box-sizing: border-box;
        cursor: pointer;
        transition:
          border-color 0.2s ease,
          background-color 0.2s ease,
          box-shadow 0.2s ease,
          transform 0.2s ease;
      }

      .clk-card-finance:hover {
        border-color: #02a6df;
        background: #ffffff;
        box-shadow: 0 4px 12px rgba(2, 166, 223, 0.12);
        transform: translateY(-1px);
      }

      .clk-card-finance:focus-visible {
        outline: 2px solid #02a6df;
        outline-offset: 2px;
      }

      .clk-card-finance__copy {
        display: flex;
        flex: 1 1 auto;
        flex-direction: column;
        min-width: 0;
        line-height: 1.2;
      }

      .clk-card-finance__eyebrow {
        display: block;
        margin-bottom: 3px;
        color: #667085;
        font-size: 12px;
        font-weight: 400;
        white-space: nowrap;
      }

      .clk-card-finance__payment {
        display: flex;
        align-items: baseline;
        flex-wrap: wrap;
        gap: 2px;
        color: #667085;
        font-size: 12px;
        white-space: nowrap;
      }

      .clk-card-finance__amount {
        color: #02a6df;
        font-size: 15px;
        font-weight: 700;
      }

      .clk-card-finance__period {
        color: #667085;
        font-size: 12px;
        font-weight: 600;
      }

      .clk-card-finance__brand {
        margin-left: 3px;
        color: #667085;
        font-size: 11px;
        font-weight: 500;
      }

      .clk-card-finance__cta {
        position: relative;
        display: inline-flex;
        flex: 0 0 auto;
        align-items: center;
        justify-content: center;
        min-width: 78px;
        min-height: 30px;
        padding: 0 18px;
        border-radius: 999px;
        background: #02a6df;
        color: #ffffff;
        font-size: 11px;
        font-weight: 700;
        line-height: 1;
        letter-spacing: 0.3px;
        text-align: center;
        text-transform: uppercase;
        white-space: nowrap;
        transition: background-color 0.2s ease;
      }

      .clk-card-finance:hover .clk-card-finance__cta {
        background: #008fc4;
      }

      @container (max-width: 320px) {
        .clk-product-finance {
          gap: 5px;
          padding-inline: 6px;
        }

        .clk-product-finance__copy {
          gap: 2px;
        }

        .clk-product-finance__label,
        .clk-product-finance__with,
        .clk-product-finance__period {
          font-size: 10px;
        }

        .clk-product-finance__amount {
          font-size: 15px;
        }

        .clk-product-finance__brand {
          font-size: 11px;
        }

        .clk-product-finance__cta {
          min-width: 75px;
          min-height: 26px;
          padding-inline: 16px;
          font-size: 8px;
          letter-spacing: 0.2px;
        }

        .clk-product-finance .clk-finance-arrow {
          width: 8px;
          height: 8px;
          right: 7px;
          margin-top: -4px;
        }
      }

      @container (max-width: 225px) {
        .clk-card-finance {
          gap: 6px;
          padding: 8px;
        }

        .clk-card-finance__brand {
          display: none;
        }

        .clk-card-finance__cta {
          min-width: 64px;
          min-height: 28px;
          padding-inline: 15px;
          font-size: 10px;
        }
      }

      @media (max-width: 749px) {
        .ClkButton--product {
          max-width: 100%;
          margin-top: 10px;
        }

        .clk-product-finance {
          min-height: 44px;
        }

        .ClkButton--collection {
          margin-top: 6px;
        }

        .clk-card-finance {
          min-height: 48px;
          gap: 6px;
          padding: 7px 8px;
        }

        .clk-card-finance__eyebrow {
          font-size: 11px;
        }

        .clk-card-finance__amount {
          font-size: 14px;
        }

        .clk-card-finance__brand {
          display: none;
        }

        .clk-card-finance__cta {
          min-width: 64px;
          min-height: 28px;
          padding-inline: 15px;
          font-size: 10px;
        }

        .clk-card-finance__cta .clk-finance-arrow {
          right: 7px;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .clk-product-finance,
        .clk-product-finance__cta,
        .clk-card-finance,
        .clk-card-finance__cta,
        .clk-finance-arrow {
          transition: none;
        }

        .clk-product-finance:hover,
        .clk-card-finance:hover {
          transform: none;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function findExistingButton(place) {
    if (!place?.parentElement) return null;
    return place.parentElement.querySelector(":scope > .ClkButton");
  }

  function createButtonContainer(isCollection, amount) {
    const container = document.createElement("div");

    container.className = isCollection
      ? "ClkButton ClkButton--collection"
      : "ClkButton ClkButton--product";

    container.dataset.clickleaseAmount = String(amount);

    return container;
  }

  async function requestMonthlyPayment(amount) {
    const response = await fetch(
      CONFIG.apiUrl + encodeURIComponent(amount),
      {
        method: "GET",
        mode: "cors",
        credentials: "omit"
      }
    );

    if (!response.ok) {
      throw new Error(`Clicklease API returned ${response.status}`);
    }

    return parseMonthlyPayment(await response.text());
  }

  async function renderPayment(place, amount, isCollection) {
    if (!place) return;

    const existingButton = findExistingButton(place);

    if (
      !Number.isFinite(amount) ||
      amount < CONFIG.minAmount ||
      amount > CONFIG.maxAmount
    ) {
      pendingRequests.delete(place);
      existingButton?.remove();
      return;
    }

    if (
      existingButton?.dataset.clickleaseAmount === String(amount)
    ) {
      return;
    }

    existingButton?.remove();

    if (pendingRequests.get(place) === amount) return;

    pendingRequests.set(place, amount);

    try {
      const monthlyPayment = await requestMonthlyPayment(amount);

      if (
        pendingRequests.get(place) !== amount ||
        !monthlyPayment ||
        !place.isConnected
      ) {
        return;
      }

      const latestButton = findExistingButton(place);

      if (
        latestButton?.dataset.clickleaseAmount === String(amount)
      ) {
        return;
      }

      latestButton?.remove();

      const container = createButtonContainer(
        isCollection,
        amount
      );

      container.innerHTML = isCollection
        ? collectionButton(monthlyPayment)
        : productButton(monthlyPayment);

      place.after(container);
    } catch (error) {
      console.error(
        "Clicklease payment request failed:",
        error
      );
    } finally {
      if (pendingRequests.get(place) === amount) {
        pendingRequests.delete(place);
      }
    }
  }

  function getProductElements() {
    const productInfo = document.querySelector(
      SELECTORS.productInfo
    );

    if (!productInfo) return {};

    const place =
      productInfo.querySelector(
        ".hdt-price-wrapp.hdt-price--show-badge"
      ) ||
      productInfo.querySelector(".hdt-price-wrapp");

    const price =
      productInfo.querySelector(
        ".hdt-price__sale:not([hidden]) hdt-price .hdt-money"
      ) ||
      productInfo.querySelector(
        ".hdt-price__nopick:not([hidden]) hdt-price .hdt-money"
      ) ||
      productInfo.querySelector(
        "hdt-price:not([hidden]) .hdt-money"
      ) ||
      productInfo.querySelector(
        "hdt-price .hdt-money"
      );

    const priceHost =
      place?.closest(".hdt-product__price") ||
      place?.parentElement;

    priceHost?.classList.add("clk-product-price-host");

    return {
      productInfo,
      place,
      price
    };
  }

  function observeProductPrice(place) {
    if (!place || observedPriceWrappers.has(place)) return;

    observedPriceWrappers.add(place);

    const observer = new MutationObserver(scheduleStart);

    observer.observe(place, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["hidden"]
    });
  }

  function renderProductButton() {
    const { place, price } = getProductElements();

    if (!place || !price) return;

    observeProductPrice(place);

    renderPayment(
      place,
      parsePrice(price.textContent),
      false
    );
  }

  function renderCollectionButtons() {
    document
      .querySelectorAll(SELECTORS.collectionCards)
      .forEach((card) => {
        const place =
          card.querySelector(SELECTORS.cardPriceWrapper) ||
          card.querySelector(".hdt-price-wrapp");

        const price = card.querySelector(
          SELECTORS.cardPrice
        );

        if (!place || !price) return;

        renderPayment(
          place,
          parsePrice(price.textContent),
          true
        );
      });
  }

  function start() {
    if (document.querySelector(SELECTORS.productInfo)) {
      renderProductButton();
      return;
    }

    renderCollectionButtons();
  }

  function scheduleStart() {
    window.clearTimeout(scheduleStart.timer);

    scheduleStart.timer = window.setTimeout(
      start,
      120
    );
  }

  function observeDynamicContent() {
    const observer = new MutationObserver((mutations) => {
      const shouldUpdate = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some(
          (node) =>
            node instanceof Element &&
            (
              node.matches?.(".hdt-card-product") ||
              node.querySelector?.(".hdt-card-product") ||
              node.matches?.(SELECTORS.productInfo) ||
              node.querySelector?.(SELECTORS.productInfo)
            )
        )
      );

      if (shouldUpdate) {
        scheduleStart();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener(
      "variant:change",
      scheduleStart
    );

    document.addEventListener(
      "products:update",
      scheduleStart
    );

    document.addEventListener(
      "lazyhtml:added",
      scheduleStart
    );
  }

  function arrowImage() {
    return `
      <img
        class="clk-finance-arrow"
        src="${assetUrl("clicklease-arrow.svg")}"
        alt=""
        width="9"
        height="9"
        loading="eager"
      >
    `;
  }

  function productButton(monthlyPayment) {
    return `
      <a
        class="clk-product-finance"
        href="${CONFIG.partnerUrl}"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Apply for Clicklease financing from $${monthlyPayment} per month"
      >
        <span class="clk-product-finance__copy">
          <span class="clk-product-finance__label">
            As low as
          </span>

          <strong class="clk-product-finance__amount">
            $${monthlyPayment}
          </strong>

          <span class="clk-product-finance__period">
            /mo
          </span>

          <span class="clk-product-finance__with">
            with
          </span>

          <span class="clk-product-finance__brand">
            <span class="clk-product-finance__brand-click">
              click
            </span>lease
          </span>
        </span>

        <span
          class="clk-product-finance__cta"
          aria-hidden="true"
        >
          Apply now
          ${arrowImage()}
        </span>
      </a>
    `;
  }

  function collectionButton(monthlyPayment) {
    return `
      <a
        class="clk-card-finance"
        href="${CONFIG.partnerUrl}"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Apply for Clicklease financing from $${monthlyPayment} per month"
      >
        <span class="clk-card-finance__copy">
          <span class="clk-card-finance__eyebrow">
            Financing as low as
          </span>

          <span class="clk-card-finance__payment">
            <strong class="clk-card-finance__amount">
              $${monthlyPayment}
            </strong>

            <span class="clk-card-finance__period">
              /month
            </span>

            <span class="clk-card-finance__brand">
              with Clicklease
            </span>
          </span>
        </span>

        <span
          class="clk-card-finance__cta"
          aria-hidden="true"
        >
          Apply
          ${arrowImage()}
        </span>
      </a>
    `;
  }

  function initialize() {
    injectStyles();
    start();
    observeDynamicContent();
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => window.setTimeout(initialize, 500),
      { once: true }
    );
  } else {
    window.setTimeout(initialize, 500);
  }
})();